import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { getFoodGroup } from '../../selectors'
import { getFullFileUrl } from '../../utils/formatData'
import {
    clsx,
    ensureArray,
    getBodyScrollTop,
    matchFood,
} from '../../utils/helper'

import FoodItemContainer from './FoodItemContainer'
import MenuContainer from './MenuContainer'
import RestaurantInfoContainer from './RestaurantInfoContainer'
import useDisplayGroup from '../../hooks/useDisplayGroup'
import { useTranslation } from 'react-i18next'
import { getListFoodAdded } from '../../selectors/order'
import useDidMountEffect from '../../hooks/useDidMountEffect'
import BaseModal from '../../components/common/base-modal'
import ModalHeader from '../../components/common/base-modal/ModalHeader'

const FoodContainer = () => {
    const foodsGrouped = useSelector(state => state.FoodReducer)
    const foodGroupInfo = useSelector(getFoodGroup)
    const foodOrdering = useSelector(getListFoodAdded)

    const { t } = useTranslation()

    const {
        handleSetDisplayGroup,
        setDisplayGroup,
        displayGroup,
        refChangeByClick,
    } = useDisplayGroup({ isMobile: false })

    const [searchValue, setSearchValue] = useState('')
    const [beilageFoodShowing, setBeilageFoodShowing] = useState(-1)
    const [moreInfo, setMoreInfo] = useState('')
    const [scrollTopPosition, setScrollTopPosition] = useState()

    const listGroupRef = useRef([])

    const checkInView = el =>
        el.getBoundingClientRect().y < window.innerHeight / 2

    const handleScroll = () => {
        setScrollTopPosition(getBodyScrollTop().scrollTop)
    }

    const handleChangeGroupByClick = group => {
        refChangeByClick.current = true
        handleSetDisplayGroup(group)
    }

    useEffect(() => {
        const scrollEle = getBodyScrollTop()

        scrollEle.addEventListener('scroll', handleScroll)

        return () => {
            scrollEle.removeEventListener('scroll', handleScroll)
        }
    }, [])

    useDidMountEffect(() => {
        const timeOut = setTimeout(() => {
            if (refChangeByClick.current) {
                return (refChangeByClick.current = false)
            }

            const listChilds = ensureArray(listGroupRef.current)
            let childActive = ''
            for (let i = listChilds.length - 1; i > -1; i--) {
                const child = listChilds[i]
                if (child && checkInView(child)) {
                    childActive = +child.getAttribute('group-data')
                    break
                }
            }

            childActive &&
                childActive !== displayGroup &&
                setDisplayGroup(childActive)
        }, 100)

        return () => {
            timeOut && clearTimeout(timeOut)
        }
    }, [scrollTopPosition])

    const getGroupFoodData = () => {
        const foodsGroupedFiltered = Object.keys(foodsGrouped).reduce(
            (rs, cur) => ({
                ...rs,
                [cur]: foodsGrouped[cur].filter(f => matchFood(searchValue, f)),
            }),
            {}
        )

        return foodGroupInfo
            .map(g => {
                const listFoodByGroup = foodsGroupedFiltered[g.id]

                return listFoodByGroup?.length
                    ? {
                        groupInfo: g,
                        listFood: listFoodByGroup.map(el => {
                            const ids = el.subs
                                ? el.subs.map(f => f.id)
                                : [el.id]
                            return {
                                ...el,
                                hasInCart: !!foodOrdering.find(f =>
                                    ids.includes(f.foodDetails?.id)
                                ),
                            }
                        }),
                    }
                    : false
            })
            .filter(Boolean)
    }

    const foodsGroupShow = getGroupFoodData()

    return (
        <div className="food-desk-main">
            <RestaurantInfoContainer />
            <MenuContainer
                displayGroup={displayGroup}
                handleSetDisplayGroup={handleChangeGroupByClick}
                setSearchValue={setSearchValue}
            />

            <BaseModal
                isOpen={!!moreInfo}
                contentClassName="food-info-more"
                onRequestClose={() => setMoreInfo('')}
            >
                <ModalHeader onClose={() => setMoreInfo('')}>{t('modalMoreInfo.title')}</ModalHeader>
                <div
                    className="content paragraph-2 mt-4"
                    dangerouslySetInnerHTML={{ __html: moreInfo }}
                />
            </BaseModal>

            {foodsGroupShow.map((g, index) => (
                <div
                    className={clsx([
                        'group-food container-fluid container-xl',
                        // !index && 'first',
                        !g.groupInfo.imagePath && 'hide-banner',
                    ])}
                    id={`group-${g.groupInfo.id}`}
                    key={g.groupInfo.id}
                    group-data={g.groupInfo.id}
                    ref={ref => (listGroupRef.current[index] = ref)}
                >
                    <div className="banner">
                        <div className="banner-img">
                            <img src={getFullFileUrl(g.groupInfo.imagePath)} />
                        </div>
                        <div className="name">{g.groupInfo.name}</div>
                        <div className="description">{g.groupInfo.description}</div>
                    </div>

                    <div className="list-food-by-group">
                        {g.listFood.map(f => (
                            <FoodItemContainer
                                beilageFoodShowing={beilageFoodShowing}
                                setBeilageFoodShowing={setBeilageFoodShowing}
                                food={f}
                                key={f.id}
                                setMoreInfo={setMoreInfo}
                                hasInCart={f.hasInCart}
                            />
                        ))}
                    </div>
                </div>
            ))}
        </div>
    )
}

export default FoodContainer
